/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */

window.sbBehaviours = window.sbBehaviours || {};
sbBehaviours.forgotUserName = {

    valiateOTP: function () {
        this._callSucessPage();
    }

}
/*sbBehaviours.authAndSubmit = {
    submitDetails: function () {
        // submit functionality goes here
    },

    setAuthorizationModes: function (header) {
        this.authMethods = [];
        if (header.primaryAccessCode == "TPWD" && (!header.secondaryAccessCode ||
            header.secondaryAccessCode == '')) {
            this.authMethods = [{
                'method': 'TPWD',
                'wrapperValue': ''
            }];
        }
        if (header.primaryAccessCode == "SOTP" && (!header.secondaryAccessCode ||
            header.secondaryAccessCode == '')) {
            this.authMethods = [{
                'method': 'SOTP',
                'resendUrl': '',
                'wrapperValue': ''
            }];
        }
        if (header.primaryAccessCode == "TPWD" && header.secondaryAccessCode == "SOTP" || header.secondaryAccessCode == "OTP") {
            this.authMethods = [{
                'method': 'TPWD',
                'wrapperValue': ''
            }, {
                'method': 'SOTP',
                'resendUrl': '',
                'wrapperValue': ''
            }];
        }
        if (header.primaryAccessCode == "SOTP" && header.secondaryAccessCode == "TPWD") {
            this.authMethods = [{
                'method': 'SOTP',
                'resendUrl': '',
                'wrapperValue': ''
            }, {
                'method': 'TPWD',
                'wrapperValue': ''
            }
            ];
        }
    }
}*/
